import { render, staticRenderFns } from "./InboxAddHover.vue?vue&type=template&id=b54390e8"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b54390e8')) {
      api.createRecord('b54390e8', component.options)
    } else {
      api.reload('b54390e8', component.options)
    }
    module.hot.accept("./InboxAddHover.vue?vue&type=template&id=b54390e8", function () {
      api.rerender('b54390e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/InboxAddHover.vue"
export default component.exports